import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import style from '../css/Home.module.css';
import Navbar from '../navigation/Navbar';
import axios from 'axios';
import { FaCircleCheck, FaScrewdriverWrench } from 'react-icons/fa6';
import OfferImage from '../components/OfferImage';
import {
	FaBars,
	FaHome,
	FaList,
	FaPowerOff,
	FaServicestack,
	FaTeamspeak,
	FaThumbsUp,
	FaTruckMoving,
	FaUser,
} from 'react-icons/fa';
import HeaderBar from '../components/HeaderBar';
import HomeBtn from '../components/HomeBtn';
import Services from '../components/Services';

function Home() {
	const [services, setServices] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState('');
	const [agents, setAgents] = useState({}); // State to store agents' details by service
	const navigate = useNavigate();

	// Fetch user email from localStorage
	const userEmail = JSON.parse(localStorage.getItem('user'))?.email;

	// Fetch services based on the user's email
	useEffect(() => {
		if (!userEmail) {
			navigate('/');
			return;
		}

		const fetchServices = async () => {
			try {
				const response = await axios.get(
					'https://hometech-repairs.in/customerDB/FetchBooking.php',
					{
						params: { email: userEmail },
					}
				);
				if (response.data.status) {
					setServices(response.data.data);
				} else {
					setError('No upcoming services found');
				}
			} catch (err) {
				setError('Failed to fetch services. Please try again later.');
			} finally {
				setLoading(false);
			}
		};

		fetchServices();
	}, [userEmail, navigate]);

	useEffect(() => {
		const fetchAgentDetails = async (agentId) => {
			try {
				const response = await fetch(
					`https://hometech-repairs.in/homeTech/FetchAgent.php?id=${agentId}`
				);
				const result = await response.json();
				if (result.status) {
					setAgents((prevAgents) => ({
						...prevAgents,
						[agentId]: result.data, // Store agent details by agentId
					}));
				}
			} catch (err) {
				console.error('Error fetching agent details:', err);
			}
		};

		// Call the fetchAgentDetails function for each unique agent_id
		services.forEach((service) => {
			if (service.agent_id && !agents[service.agent_id]) {
				fetchAgentDetails(service.agent_id);
			}
		});
	}, [services, agents]);

	const handleLogout = () => {
		localStorage.clear();
		navigate('/');
	};

	return (
		<div>
			{/* <Navbar /> */}
			<HeaderBar
				text={'Hello ' + JSON.parse(localStorage.getItem('user'))?.name}
				icon={<FaUser color="black" size={20} />}
				navi="/profile"
			/>
			<div className={style.main}>
				<p>Website is under construction.</p>

				<OfferImage />

				<Services />

				<div style={{ textAlign: 'center', marginTop: '20px' }}>
					<p>
						© 2025 HomeTech Repairs. <br /> All rights reserved.
					</p>
				</div>
			</div>

			<div className={style.btns}>
				<HomeBtn
					toLink={'/upcoming-service'}
					icon={<FaScrewdriverWrench color="black" size={15} />}
					text={'Upcoming'}
				/>

				<HomeBtn
					toLink={'/book-repair'}
					icon={<FaTruckMoving color="black" size={15} />}
					text={'Booking'}
				/>

				<HomeBtn
					toLink={'/service-history'}
					icon={<FaList color="black" size={15} />}
					text={'History'}
				/>

				<HomeBtn
					toLink={'/more'}
					icon={<FaBars color="black" size={15} />}
					text={'Menu'}
				/>

				{/* <HomeBtn
					toLink={'/feed-back'}
					icon={<FaThumbsUp color="black" size={15} />}
					text={'Feedback'}
				/>

				<HomeBtn
					toLink={'/support'}
					icon={<FaTeamspeak color="black" size={15} />}
					text={'Support'}
				/> */}
			</div>
		</div>
	);
}

export default Home;

{
	/* s27ekta@gmail.com */
}
